import * as React from 'react';
import Button, { Props as ButtonProps } from '../Button/Button';

export interface Props extends ButtonProps {}

/**
 * The content that goes inside a Card. This is the component
 * that should be used to create padding, which can also be divided
 * with the CardDivider.
 */
const CardButton: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <Button { ...props } borderless />
  );
};

export default CardButton;
